import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function MSListAccountAdminStorage({ handleDrawerToggle, onActive }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/storage/assigning-storage'}
                onClick={handleDrawerToggle}
                secondary={'Assigning Storage'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/storage/signiant-server/install'}
                onClick={handleDrawerToggle}
                secondary={'Installing SDCX Servers'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/storage/signiant-server/upgrade'}
                onClick={handleDrawerToggle}
                secondary={'Upgrading SDCX Servers'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/storage/cloud-storage'}
                onClick={handleDrawerToggle}
                secondary={'Configuring Cloud Storage'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/storage/s3-compatible-storage'}
                onClick={handleDrawerToggle}
                secondary={'Configuring S3 Compatible Storage'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/storage/multiple-servers'}
                onClick={handleDrawerToggle}
                secondary={'Assigning Multiple Servers'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/storage/signiant-server/advanced-configuration'}
                onClick={handleDrawerToggle}
                secondary={'Advanced Configuration'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/storage/signiant-server/relays'}
                onClick={handleDrawerToggle}
                secondary={'Server Routing and Relays'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/media-shuttle/account-administration/storage/signiant-server/logs'}
                onClick={handleDrawerToggle}
                secondary={'Server Logs'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={
                    '/media-shuttle/account-administration/storage/signiant-server/communication-service-troubleshooting'
                }
                onClick={handleDrawerToggle}
                secondary={'Troubleshooting'}
            />
        </List>
    );
}

MSListAccountAdminStorage.propTypes = {
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default MSListAccountAdminStorage;
